import { StructuredMetadataTable } from '@backstage/core-components';
import { Typography } from '@material-ui/core';

import { FormProvider } from 'react-hook-form';
import { Account, Features } from '../types';
import { BudgetInput } from './BudgetInput';
import { BaseEditIcon } from '../BaseEditIcon';

interface BudgetEditIconProps {
  workloadData: Account | undefined;
  requesterEmail: string;
  features: Features;
  cardClass: string;
  cardContentClass: string;
  apiValidationPayload: any;
  isModalOpen: boolean;
  isLoading: boolean;
  isLoadingEdit: boolean;
  handleClickOpen: any;
  handleClose: any;
  handleConfirm: any;
  disableConfirm: boolean;
}

export function BudgetEditIcon(props: BudgetEditIconProps) {
  return (
    <BaseEditIcon
      {...props}
      dialogTitle="Update Budget"
      settingName="Budget"
      allowOwnerEdit
      allowEngineerEdit
    >
      <FormProvider {...props.apiValidationPayload.form}>
        <StructuredMetadataTable
          metadata={{
            'Budget Amount': (
              <>
                <BudgetInput
                  apiValidation={props.apiValidationPayload}
                  existingBudgetAmount={String(props.features?.budget?.amount)}
                  nonGovernanceValidation={false}
                  disabled={props.isLoading}
                />
              </>
            ),
          }}
        />
        <Typography>
          Budget can not be $0. Must be different from current budget.
        </Typography>
        <Typography>
          The changes will take a few minutes to deploy and update.
        </Typography>
      </FormProvider>
    </BaseEditIcon>
  );
}
